import React from 'react';
import { CustomModal } from '../../../../common/CustomModal';
import '../../../../../styles/components/bidders-list.scss';
import {
  formatAmount,
  formatDate,
  formatNumber,
  getAvatarColor,
  getInitials,
} from '../../../../../utils/common';
import { Award, Crown, Medal, Star } from 'lucide-react';
import i18n from '../../../../../i18n';

export class BiddersList extends React.Component {
  handleCancel = () => {
    this.props.onClose();
  };

  getRankBadge = (index, isWinner) => {
    if (isWinner) {
      return (
        <span className="rank-badge winner">
          <Crown size={14} strokeWidth={1.5} /> Winner
        </span>
      );
    }

    const rank = index + 1;
    if (rank === 1)
      return (
        <span className="rank-badge rank-1">
          <Medal size={14} strokeWidth={1.5} /> {i18n.t('1st')}
        </span>
      );
    if (rank === 2)
      return (
        <span className="rank-badge rank-2">
          <Award size={14} strokeWidth={1.5} /> {i18n.t('2nd')}
        </span>
      );
    if (rank === 3)
      return (
        <span className="rank-badge rank-3">
          <Star size={14} strokeWidth={1.5} /> {i18n.t('3rd')}
        </span>
      );
    return <span className="rank-badge rank-other">#{rank}</span>;
  };

  render() {
    const { show, bidders = [] } = this.props;
    const isArabic = i18n.language === 'ar';

    return (
      <CustomModal isOpen={show} header={i18n.t('bidders_list')} onClose={this.handleCancel}>
        <div className="bidders-container">
          {bidders.length === 0 ? (
            <div className="no-bidders">
              <p>{i18n.t('no_bidders_yet')}</p>
            </div>
          ) : (
            <div className="bidders-list">
              {bidders.map((bidder, index) => (
                <div
                  key={bidder.id}
                  className={`bidder-card ${bidder.winner ? 'winner-card' : ''}`}
                >
                  <div className="bidder-rank">{this.getRankBadge(index, bidder.winner)}</div>

                  <div className="bidder-content">
                    <div className="bidder-avatar-section">
                      <div
                        className="bidder-avatar"
                        style={{ backgroundColor: getAvatarColor(bidder.user_id) }}
                      >
                        {getInitials(bidder.user?.name)}
                      </div>
                      <div className="bidder-info">
                        <h3 className="bidder-name">{bidder.user?.name || 'Unknown'}</h3>
                        <div className="bidder-meta">
                          <span className="bidder-id">
                            {i18n.t('id')}:
                            {formatNumber(bidder.user_id, isArabic ? 'ar-EG-u-nu-arab' : 'en-US')}
                          </span>
                          <span className="bidder-separator">•</span>
                          <span className="bid-id">
                            {i18n.t('bid')} #
                            {formatNumber(bidder.id, isArabic ? 'ar-EG-u-nu-arab' : 'en-US')}
                          </span>
                        </div>
                        <div className="bidder-contact">
                          <span className="bidder-email">{bidder.user?.email}</span>
                        </div>
                      </div>
                    </div>

                    <div className="bidder-amount-section">
                      <div className="bid-amount ">
                        {formatAmount(bidder.bid_amount, isArabic ? 'ar-OM-u-nu-arab' : 'en-US')}
                      </div>
                      <div className="bid-date">
                        {formatDate(bidder.created_at, isArabic ? 'ar-EG-u-nu-arab' : 'en-US')}
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          )}

          {bidders.length > 0 && (
            <div className="bidders-footer">
              <p>
                {i18n.t('total_bidders')} <strong>{bidders.length}</strong>
              </p>
            </div>
          )}
        </div>
      </CustomModal>
    );
  }
}
